export default __webpack_public_path__ + "icons/apple-touch-icon-c64b37c077b31c9a462cca4ad74d3d95.png";